import { render, staticRenderFns } from "./RolesDropdown.vue?vue&type=template&id=70a18acc&"
import script from "./RolesDropdown.vue?vue&type=script&lang=js&"
export * from "./RolesDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports